import { Skeleton, Stack } from "@mui/material";

const CarouselSkeleton = () => {
  return (
    <Stack>
      <Skeleton variant="text" width={70} />
      <Skeleton variant="rectangular" width="100%" height={200} />
    </Stack>
  );
};

export default CarouselSkeleton;
